<template>
	<v-dialog
		persistent
		width="auto"
		v-model="showDialog"
		v-if="selectedAttachment"
	>
		<v-card
			style="min-height: 50vh; max-height: 80vh; width: 33vw; min-width: 400px"
			class="d-flex flex-column"
		>
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{
							$t("attachment-details-header")
						}}</v-toolbar-title>
					</v-col>
					<v-spacer></v-spacer>
					<v-icon @click="$emit('closeDialog')" class="white-icon"
						>mdi-close</v-icon
					>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column overflow-y-auto">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="10" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">
								{{ $t("type") }}:
							</div>
							<div class="text-body-1">
								{{ selectedAttachment.documentType }}
							</div>
						</v-col>

						<v-col cols="2" class="text-right">
							<v-tooltip left>
								<template v-slot:activator="{ on }">
									<v-icon
										size="25"
										v-on="on"
										color="primary"
										@click="
											$emit(
												'downloadAttachment',
												selectedAttachment.id,
												selectedAttachment.fileName,
												'ccmAttachment'
											)
										"
									>
										mdi-cloud-download
									</v-icon>
								</template>
								{{ $t("download-file") }}
							</v-tooltip>

							<v-tooltip left>
								<template v-slot:activator="{ on }">
									<v-icon
										size="25"
										color="primary"
										v-on="on"
										v-if="
											!excludedFileExtensions.includes(
												selectedAttachment.fileExtension
											)
										"
										@click="
											$emit(
												'openFileInNewTab',
												selectedAttachment.id,
												'ccmAttachment'
											)
										"
									>
										mdi-open-in-new
									</v-icon>
								</template>
								{{ $t("open-in-new-tab") }}
							</v-tooltip>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">
								{{ $t("file-name") }}:
							</div>
							<div class="text-body-1">{{ selectedAttachment.fileName }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">
								{{ $t("notes") }}:
							</div>
							<!-- prettier-ignore -->
							<div class="text-body-1" style="white-space: pre-wrap">{{ selectedAttachment.notes }}</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col cols="8" class="text-left">
						<span class="text-subtitle-1 font-weight-bold"
							>{{ $t("timestamp") }}:</span
						>
						<span class="text-body-1">
							{{
								formatTimestamp(selectedAttachment.uploadedAt, "datetime_med")
							}}
						</span>
					</v-col>
					<v-col cols="4" class="text-right">
						<span class="text-subtitle-1 font-weight-bold"
							>{{ $t("By") }}:</span
						>
						<span class="text-body-1">{{ selectedAttachment.uploadedBy }}</span>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '@/utils/utilities';
export default {
	name: 'CCMAttachmentViewDialog',

	props: ['showDialog', 'selectedAttachment', 'excludedFileExtensions'],

	methods: {
		formatTimestamp,
	},
};
</script>
